/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FormResponse } from '../models/FormResponse';
import type { FormResponseStatus } from '../models/FormResponseStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class FormResponseStatusService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Update a form response's status by its Guid.
     * @param formDefinitionGuid
     * @param responseGuid The response's guid.
     * @param requestBody The new status for the response.
     * @returns FormResponse OK
     * @throws ApiError
     */
    public updateFormResponseStatus(
        formDefinitionGuid: string,
        responseGuid: string,
        requestBody?: FormResponseStatus,
    ): CancelablePromise<FormResponse> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/mwforms/{formDefinitionGuid}/status/{responseGuid}/UpdateFormResponseStatus',
            path: {
                'formDefinitionGuid': formDefinitionGuid,
                'responseGuid': responseGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
